import type { IGrowthOverviewTableRow } from "../types";

export const findGrowthOverviewRowById = (
    rows: IGrowthOverviewTableRow[],
    rowId: string,
): IGrowthOverviewTableRow | undefined => {
    for (const row of rows) {
        if (row.id === rowId) {
            return row;
        }

        if (row.children?.length) {
            const found = findGrowthOverviewRowById(row.children, rowId);
            if (found) {
                return found;
            }
        }
    }

    return undefined;
};
